function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { motion } from 'framer-motion';
var fadeVariant = {
  visible: {
    opacity: 1
  },
  hidden: {
    opacity: 0
  }
};

var Fade = function Fade(props) {
  var pose = props.pose,
      className = props.className,
      additionalProps = _objectWithoutProperties(props, ["pose", "className"]);

  return React.createElement(motion.div, _extends({
    initial: 'hidden'
  }, additionalProps, {
    className: classnames(className),
    animate: pose,
    variants: fadeVariant
  }), props.children);
};

Fade.propTypes = {
  pose: PropTypes.string.isRequired,
  className: PropTypes.string
};
Fade.defaultProps = {
  className: ''
};
Fade.displayName = 'Fade';
export { Fade };